module.exports = __webpack_public_path__ + "img/angle-right.9db0c75b.svg";